import { ColumnConfig } from "types/reminders";

export const createReminderColumnConfig = (
  scaleFactor: number = 1,
  isPayerReminder: boolean = false
): ColumnConfig[] => {
  // a reminder by payer gathers entries of several clients, so it shows whose entry each row is
  const clientColumns: ColumnConfig[] = isPayerReminder
    ? [
        {
          columnId: "clientName",
          width: scaleFactor * 200,
          reorderable: true,
          resizable: true,
          sortable: true,
          label: "pct.clientName.label",
          cellType: "customtext",
          additionalInfo: {
            gosLink: {
              idField: "clientId",
              linkType: "client",
            },
          },
        },
      ]
    : [];
  return [
    {
      columnId: "ordinalNumber",
      width: scaleFactor * 50,
      reorderable: false,
      resizable: true,
      label: "",
      cellType: "ordinalnumber",
      sortable: false,
    },
    {
      columnId: "policyName",
      width: scaleFactor * 250,
      reorderable: true,
      resizable: true,
      sortable: true,
      label: "pct.policyName.label",
      cellType: "customtext",
      additionalInfo: {
        gosLink: {
          idField: "policyId",
          linkType: "policy",
        },
      },
    },
    {
      columnId: "insurerName",
      width: scaleFactor * 250,
      reorderable: true,
      resizable: true,
      sortable: true,
      label: "pct.insurerName.label",
      cellType: "customtext",
      additionalInfo: {
        gosLink: {
          idField: "insurerId",
          linkType: "insurer",
        },
      },
    },

    ...clientColumns,
    {
      columnId: "payerName",
      width: scaleFactor * 145,
      reorderable: true,
      resizable: true,
      sortable: true,
      label: "pct.payer.label",
      cellType: "customtext",
      additionalInfo: {
        gosLink: {
          idField: "payerId",
          linkType: "payer",
        },
      },
    },
    {
      columnId: "policyNumber",
      width: scaleFactor * 150,
      reorderable: true,
      resizable: true,
      sortable: true,
      label: "pct.policyNumber.label",
      cellType: "customtext",
      additionalInfo: undefined,
    },

    {
      columnId: "policySubNumber",
      width: scaleFactor * 150,
      reorderable: true,
      resizable: true,
      sortable: true,
      label: "pct.policySubNumber.label",
      cellType: "customtext",
      additionalInfo: undefined,
    },
    {
      columnId: "insuranceLineName",
      width: scaleFactor * 250,
      reorderable: true,
      resizable: true,
      sortable: true,
      label: "pct.insuranceLineCode.label",
      cellType: "customtext",
      additionalInfo: undefined,
    },
    {
      columnId: "comment",
      width: scaleFactor * 350,
      reorderable: true,
      resizable: true,
      sortable: true,
      label: "pct.comment.label",
      cellType: "customtext",
      additionalInfo: undefined,
    },
    {
      columnId: "bookingDate",
      width: scaleFactor * 120,
      reorderable: true,
      resizable: true,
      sortable: true,
      label: "pct.bookingDate.label",
      cellType: "datepicker",
      additionalInfo: undefined,
    },
    {
      columnId: "premiumFrom",
      width: scaleFactor * 120,
      reorderable: true,
      resizable: true,
      sortable: true,
      label: "pct.premiumFrom.label",
      cellType: "datepicker",
      additionalInfo: undefined,
    },
    {
      columnId: "premiumTo",
      width: scaleFactor * 120,
      reorderable: true,
      resizable: true,
      sortable: true,
      label: "pct.premiumTo.label",
      cellType: "datepicker",
      additionalInfo: undefined,
    },
    // {
    //   columnId: "policyPaymentFrequencyCodeId",
    //   width: scaleFactor * 150,
    //   reorderable: true,
    //   resizable: true,
    //   label: "pct.policyPaymentFrequencyCodeId.label",
    //   cellType: "taxonomy",
    //   additionalInfo: {
    //     taxonomy: "PaymentFrequency",
    //   },
    // },

    {
      columnId: "premiumAmount",
      width: scaleFactor * 120,
      reorderable: true,
      resizable: true,
      sortable: true,
      label: "pct.premiumAmount.label",
      cellType: "customnumber",
      additionalInfo: undefined,
    },
    {
      columnId: "premiumAmountWithoutTax",
      width: scaleFactor * 135,
      reorderable: true,
      resizable: true,
      sortable: true,
      label: "pct.premiumAmountWithoutTax.label",
      cellType: "customnumber",
      additionalInfo: undefined,
    },
    {
      columnId: "premiumTaxAmount",
      width: scaleFactor * 120,
      reorderable: true,
      resizable: true,
      sortable: true,
      label: "pct.premiumTaxAmount.label",
      cellType: "customnumber",
      additionalInfo: undefined,
    },
    {
      columnId: "premiumDiscount",
      width: scaleFactor * 120,
      reorderable: true,
      resizable: true,
      sortable: true,
      label: "pct.premiumDiscount.label",
      cellType: "customnumber",
      additionalInfo: undefined,
    },
    {
      columnId: "premiumDiscountPercent",
      width: scaleFactor * 120,
      reorderable: true,
      resizable: true,
      sortable: true,
      label: "pct.premiumDiscountPercent.label",
      cellType: "customnumber",
      additionalInfo: undefined,
    },
    {
      columnId: "totalPremiumAmount",
      width: scaleFactor * 120,
      reorderable: true,
      resizable: true,
      sortable: true,
      label: "pct.totalPremiumAmount.label",
      cellType: "customnumber",
      additionalInfo: undefined,
    },
    {
      columnId: "paidPremiumAmount",
      width: scaleFactor * 120,
      reorderable: true,
      resizable: true,
      sortable: true,
      label: "pct.paidPremiumAmount.label",
      cellType: "customnumber",
      additionalInfo: undefined,
    },
    {
      columnId: "premiumDebt",
      width: scaleFactor * 120,
      reorderable: true,
      resizable: true,
      sortable: true,
      label: "pct.premiumDebt.label",
      cellType: "customnumber",
      additionalInfo: undefined,
    },

    {
      columnId: "suggestedPaymentAmount",
      width: scaleFactor * 180,
      reorderable: true,
      resizable: true,
      label: "pct.reminderValue.label",
      sortable: true,
      cellType: "clearedamount",
      additionalInfo: undefined,
    },
    {
      columnId: "select",
      width: scaleFactor * 40,
      reorderable: false,
      resizable: false,
      label: "",
      cellType: "select",
      sortable: false,
      additionalInfo: {
        rowIdField: "paymentPlanEntryId",
      },
    },
  ];
};
